<footer *ngIf="!isStudent" class="container-wrapper selenium-app-footer" id="footer">
    <div class="container">
        <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 mobile-top-section">
                <div class="student-view-button">
                    <a
                        class="{{ gtmPrefix + 'student-button ' + 'btn' }}"
                        href="/student/"
                        target="_blank"
                        rel="noopener noreferrer"
                        role="button"
                        aria-label="Access student site"
                    >
                        <em class="fas fa-external-link-alt"></em>
                        For students
                    </a>
                </div>
                <div class="in-partnership">In partnership with</div>
                <div class="logos">
                    <a
                        class="{{ gtmPrefix + 'logo-pbs ' + 'logo-pbs' }}"
                        [attr.data-gtmlabel]="'PBS'"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img [src]="pbsLogoWhite" alt="PBS LearningMedia" />
                    </a>
                    <a
                        class="{{ gtmPrefix + 'logo-wgbh ' + 'logo-wgbh' }}"
                        [attr.data-gtmlabel]="'WGBH'"
                    >
                        <img
                            src="https://d43fweuh3sg51.cloudfront.net/defaults/wgbh-logo.svg"
                            alt="WGBH logo"
                        />
                    </a>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-4">
                <section class="social-media">
                    <div class="social-media__inner">
                        <h3 class="footer-title">Connect With Us</h3>
                        <p class="sign-up-for">
                            Sign up for our newsletter for the latest resources, news, and more.
                        </p>
                        <div class="input-group">
                            <input
                                type="email"
                                id="email-eloqua-newsletter"
                                placeholder="Your email"
                                class="form-control input-email"
                                title="Please enter a valid email address."
                                required
                            />
                            <span class="input-group-btn input-group-append">
                                <span
                                    class="{{
                                        gtmPrefix +
                                            'newsletter-go ' +
                                            'input-group-text btn btn-success'
                                    }}"
                                    id="eloqua-newsletter-go"
                                    [attr.data-gtmlabel]="'Go'"
                                    (click)="subscribe()"
                                    >Sign up!</span
                                >
                            </span>
                        </div>
                        <a
                            href="https://www.facebook.com/pbsteachers"
                            class="social-media__link"
                            target="_blank"
                            rel="noopener noreferrer"
                            ><i class="fab fa-facebook-f"></i>Facebook</a
                        >
                        <a
                            href="https://twitter.com/pbsteachers"
                            class="social-media__link"
                            target="_blank"
                            rel="noopener noreferrer"
                            ><i class="fab fa-twitter"></i>Twitter</a
                        >
                        <a
                            href="https://www.pinterest.com/pbslm/"
                            class="social-media__link"
                            target="_blank"
                            rel="noopener noreferrer"
                            ><i class="fab fa-pinterest"></i>Pinterest</a
                        >
                    </div>
                </section>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-3 col-lg-4 learn-more">
                <h3 class="footer-title">Learn More</h3>
                <ul class="no-list-style">
                    <li class="secondary-nav__item">
                        <a
                            href="https://www.pbs.org/education/"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="{{ gtmPrefix + 'pbs-education' }}"
                            [attr.data-gtmlabel]="'PBS Education'"
                            >PBS Education</a
                        >
                    </li>
                    <li class="secondary-nav__item">
                        <a href="#" role="button" (click)="openFeedbackForm($event)">Contact Us</a>
                    </li>
                    <li class="secondary-nav__item">
                        <a
                            href="/help/"
                            class="{{ gtmPrefix + 'help' }}"
                            [attr.data-gtmlabel]="'Help'"
                            >Help</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="copyright-wrapper">
        <div class="legal-and-contact">
            <div class="col-12">
                <div class="rights-reserved">
                    &copy; {{ currentYear }} PBS &amp; WGBH Educational Foundation. All rights
                    reserved.
                </div>
                <div class="terms-and-privacy-policy">
                    <a href="/help/terms-of-use/" target="_blank" rel="noopener noreferrer"
                        >Terms of Use</a
                    >
                    <span>|</span
                    ><a href="/help/privacy-policy/" target="_blank" rel="noopener noreferrer"
                        >Privacy Policy</a
                    >
                </div>
            </div>
        </div>
    </div>
    <div
        id="feedbackModal"
        class="modal fade"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content"></div>
        </div>
    </div>
</footer>
